
//! filter options
const gonderilmisOptions = [
    {
        value: "Gönderilmiş",
        text: "Gönderilmiş"
      },
      {
        value: "Gönderilmemiş",
        text: "Gönderilmemiş"
      },
]

const tasimaTuruOptions = [
  {
    value: 2,
    text: "Normal Yük"
  },
  {
    value: 1,
    text: "Tehlikeli Yük"
  }
]

//! form options
const yukunTuruOptions= [
  {
    value: 307,
    text: "Metaller, fabrikasyon metal ürünleri (makine-ekipman hariç)"
  },
  {
    value: 308,
    text: "Makine-ekipman-büro malzemesi-bilgisayarlar"
  },
  {
    value: 201,
    text: "Beyaz eşya / Elektronik ürünler"
  },
  {
    value: 202,
    text: "Bozulabilir Gıda"
  },
  {
    value: 203,
    text: "Canlı Hayvan"
  },
  {
    value: 204,
    text: "Ev/Büro eşyası"
  },
  {
    value: 315,
    text: "Birarada taşınan karışık kategorideki mallar"
  },
  {
    value: 303,
    text: "Gıda ürünleri, içecekler ve tütün"
  },
  {
    value: 205,
    text: "Hammadde / Maden Ürünleri / İnşaat malzemesi"
  },
  {
    value: 207,
    text: "Kargo"
  },
  {
    value: 200,
    text: "Kereste, ağaç ürünleri"
  },
  {
    value: 305,
    text: "Elyaflar, kauçuk ve plastik ürünler"
  },
  {
    value: 304,
    text: "Kok kömürü ve rafine edilmiş petrol ürünleri"
  },
  {
    value: 312,
    text: "Mektup, koli"
  },
  {
    value: 302,
    text: "Maden ve madencilik ürünleri; metal cevherleri "
  },
  {
    value: 310,
    text: "Mobilya"
  },
  {
    value: 208,
    text: "Otomotiv / İş Makineleri"
  },
  {
    value: 300,
    text: "Tarım, avcılık ve ormancılık ürünleri; balık ve diğer balıkçılık ürünleri"
  },
  {
    value: 301,
    text: "Taşkömürü ve linyit; ham petrol ve doğalgaz"
  },
  {
    value: 309,
    text: "Taşımacılık ekipmanları"
  },
  {
    value: 209,
    text: "Tekstil ve tekstil ürünleri; deri ve deri ürünleri"
  },
  {
    value: 311,
    text: "İkincil hammaddeler; belediye atıkları ve diğer atıklar"
  },
  {
    value: 206,
    text: "İçecekler / Kuru gıda / Hububat"
  },
  {
    value: 210,
    text: "Diğer"
  },
] 


const bozulabilirGidaTuruOptions = [
  {
    value: "Büyük av eti",
    text: "Büyük av eti"
  },
  {
    value: "Dondurma",
    text: "Dondurma"
  },
  {
    value: "Dondurulmuş deniz mahsulleri",
    text: "Dondurulmuş deniz mahsulleri"
  },
  {
    value: "Dondurulmuş diğer gıdalar",
    text: "Dondurulmuş diğer gıdalar"
  },
  {
    value: "Et ürünleri (Sucuk, sosis, salam vb.)",
    text: "Et ürünleri (Sucuk, sosis, salam vb.)"
  },
  {
    value: "Hazır pişmiş gıda maddeleri (et, balık, sebze)",
    text: "Hazır pişmiş gıda maddeleri (et, balık, sebze)"
  },
  {
    value: "Küçük av eti",
    text: "Küçük av eti"
  },
  {
    value: "Kırmızı et",
    text: "Kırmızı et"
  },
  {
    value: "Kırmızı sakatat",
    text: "Kırmızı sakatat"
  },
  {
    value: "Kıyma",
    text: "Kıyma"
  },
  {
    value: "Süt ürünleri",
    text: "Süt ürünleri"
  },
  {
    value: "Yaş meyve ve sebze",
    text: "Yaş meyve ve sebze"
  },
  {
    value: "Dondurulmuş çiğ sebze ürünleri",
    text: "Dondurulmuş çiğ sebze ürünleri"
  },
  {
    value: "Çiğ süt",
    text: "Çiğ süt"
  },
  {
    value: "İşlem görmemiş deniz mahsulleri",
    text: "İşlem görmemiş deniz mahsulleri"
  },
]

const normalYukBirimi = [
  {
    value: "KG",
    text: "Kilogram"
  },
  {
    value: "TON",
    text: "Ton"
  },
  {
    value: "AD",
    text: "Adet"
  },
  {
    value: "PK",
    text: "Paket / Koli"
  },
]

const tehlikeliYukBirimi = [
  {
    value: "KG",
    text: "Kilogram"
  },
  {
    value: "L",
    text: "Litre"
  },
  {
    value: "M3",
    text: "Metreküp"
  },
  {
    value: "MG",
    text: "Miligram"
  },
]

const tehlikeliMaddeTasimaTuruOptions = [
  {
    value: "1",
    text: "Paket"
  },
  {
    value: "2",
    text: "Tank"
  },
  {
    value: "3",
    text: "Dökme"
  }
]

export { gonderilmisOptions, tasimaTuruOptions,yukunTuruOptions, bozulabilirGidaTuruOptions, normalYukBirimi, tehlikeliYukBirimi,tehlikeliMaddeTasimaTuruOptions}